import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en';
import zhTranslations from './locales/zh';

const resources = {
  en: enTranslations,
  zh: zhTranslations
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh',
    // 强制使用英文（测试用）。如果设置了 lng，将覆盖语言检测结果。
    lng: 'en',
    defaultNS: 'common',
    
    interpolation: {
      escapeValue: false
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'clipai-language',
      caches: ['localStorage']
    }
  });

export default i18n;